import { endOfWeek, startOfWeek } from 'date-fns';
import { of, OperatorFunction, pipe } from 'rxjs';
import { catchError, map, mapTo, switchMap, tap } from 'rxjs/operators';

import { CommitmentService } from '../../../coaching-commitment/services/commitment.service';
import { Dependencies } from '../../../store';
import { CommitmentSummaryItem } from '../commitment-summary-item.model';
import { calendarEventFromScheduleItemTransformer } from '../models/schedule.model';
import { ScheduleService } from '../services/schedule.service';

import { ChainGroup } from './schedule-event.epic';

export function listCommitments<TPayload>(
    deps: Dependencies,
    grp: ChainGroup<TPayload>,
): OperatorFunction<any, ChainGroup<TPayload>> {
    const service = deps.injector.get<CommitmentService>(CommitmentService);
    return pipe(
        service.listSummary(() => ({
            userId: grp.userId,
        })),
        tap((list: CommitmentSummaryItem[]) => {
            grp.currentCommitments = list;
        }),
        catchError((e) => of([])),
        mapTo(grp),
    );
}

export function listEvents<TPayload>(
    deps: Dependencies,
    grp: ChainGroup<TPayload>,
): OperatorFunction<any, ChainGroup<TPayload>> {
    const service = deps.injector.get<ScheduleService>(ScheduleService);
    const startDate = startOfWeek(grp.startDate);
    const endDate = endOfWeek(grp.startDate);

    return pipe(
        switchMap(() =>
            service.getScheduleByUser(grp.userId, startDate, endDate),
        ),
        map((events) => {
            grp.calendarEvents = events.map(
                calendarEventFromScheduleItemTransformer,
            );
        }),
        catchError((e) => of([])),
        mapTo(grp),
    );
}

export function saveEvent<TPayload>(
    deps: Dependencies,
    grp: ChainGroup<TPayload>,
): OperatorFunction<any, ChainGroup<TPayload>> {
    const service = deps.injector.get<ScheduleService>(ScheduleService);
    return pipe(
        service.createEvent(() => grp.eventData),
        tap((savedevent) => {
            grp.savedEvent = savedevent;
        }),
        catchError((e) => of(null)),
        mapTo(grp),
    );
}

export function getEvent<TPayload>(
    deps: Dependencies,
    grp: ChainGroup<TPayload>,
    eventId: number,
): OperatorFunction<any, ChainGroup<TPayload>> {
    const service = deps.injector.get<ScheduleService>(ScheduleService);
    return pipe(
        switchMap(() => service.getEvent(eventId)),
        // eslint-disable-next-line no-return-assign
        map((event) => (grp.eventData = event)),
        mapTo(grp),
    );
}

export function updateEvent<TPayload>(
    deps: Dependencies,
    grp: ChainGroup<TPayload>,
): OperatorFunction<any, ChainGroup<TPayload>> {
    const service = deps.injector.get<ScheduleService>(ScheduleService);

    return pipe(
        service.updateEvent(() => grp.eventData),
        tap((savedevent) => {
            grp.savedEvent = savedevent;
        }),
        catchError((e) => of(null)),
        mapTo(grp),
    );
}
